import {
  EdgeTypes,
  NodeTypes,
  ReactFlowProps,
  SetCenterOptions,
} from "@xyflow/react";
import EmployeeEdge from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/CustomReactFlow/Edges/EmployeeEdge";
import EmployeeRootNode from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Employees/EmployeeRootNode";
import Node from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Employees/Node";

export const nodeTypes: NodeTypes = {
  employeeNode: Node,
  customRootNode: EmployeeRootNode,
};

export const edgeTypes: EdgeTypes = { customEdge: EmployeeEdge };

export const reactFlowSettings: ReactFlowProps = {
  nodeTypes,
  edgeTypes,
  minZoom: 0.3,
  defaultEdgeOptions: {
    style: { strokeWidth: 3, stroke: "#C6D4E3", borderRadius: 50, offset: 20 },
  },
  nodesConnectable: false,
  nodesDraggable: false,
  zoomOnScroll: true,
  zoomOnDoubleClick: false,
  panOnDrag: true,
  attributionPosition: "top-left",
  fitView: true,
  fitViewOptions: { maxZoom: 0.7 },
  onlyRenderVisibleElements: true,
  proOptions: { hideAttribution: true },
};

export const setCenterOptions: SetCenterOptions = {
  zoom: 1,
  duration: 700,
};
